import axios from "axios";

const config = require(`../config/${process.env.REACT_APP_ENV}/env.json`);

export const getToken = () => {
  const session = localStorage.getItem("session");
  let token;
  if (session) {
    token = JSON.parse(session).token;
    return token;
  }
  return null;
};

const isUnauthorizedError = (error) => {
  return (
    error.response?.status == 403 &&
    error.response?.data.errorCode == "TOKEN_EXPIRED"
  );
};

export let refreshTokenPromise = null;
export const triggerRefreshToken = () => {
  refreshTokenPromise = getRefreshToken();
};
export const clearRefreshTokenPromise = () => {
  refreshTokenPromise = null;
};

const axios_retry = axios.create(); // no interceptor

const axios_normal = axios.create();
axios_normal.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalConfig = error.config;

    if (isUnauthorizedError(error)) {
      console.log("Intercepted unauthorized error", error);

      try {
        // the trick here, that `refreshingFunc` is global, e.g. 2 expired requests will get the same function pointer and await same function.
        if (!refreshTokenPromise) {
          refreshTokenPromise = getRefreshToken();
        }
        const tokenResponse = await refreshTokenPromise;
        const newToken = tokenResponse?.data?.token;
        console.log("tokenResponse", tokenResponse);
        if (tokenResponse.responseCode === "0000") {
          const updateTokenEvent = new CustomEvent("updateTokenEvent", {
            detail: { token: newToken },
          });
          window.dispatchEvent(updateTokenEvent);
        } else {
          //throw original error so the caller component receives it
          return Promise.reject(error);
        }

        // retry original request

        console.log("retry original request", originalConfig);
        return await axios_retry
          .request(originalConfig.url, {
            method: originalConfig.method,
            headers: {
              "Content-Type": "application/json",
              token: newToken,
            },
            ...(originalConfig.data && { data: originalConfig.data }),
          })
          .catch((innerError) => {
            // if original req failed with 401 again - it means server returned not valid token for refresh request
            if (isUnauthorizedError(innerError)) {
              throw innerError;
            }
          });
      } catch (err) {
        return Promise.reject(error);
      } finally {
        clearRefreshTokenPromise();
      }
    } else {
      return Promise.reject(error);
    }
  },
);

const apiCall = async (method, host, url, body) => {
  const token = getToken();
  let query = "";
  let requestBody = body; // remove for get

  if (method == "GET") {
    if (body) {
      query = "?" + new URLSearchParams(body).toString();
    }
    requestBody = null;
  }

  return await axios_normal
    .request(host + url + query, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
      ...(requestBody && { data: JSON.stringify(requestBody) }),
    })
    .then((response) => {
      const result = response;
      return result;
    })
    .catch((e) => {
      console.log("Axios error", e);
      return e.response;
    });
};

/* Interfaces */
const getRefreshToken = async () => {
  const token = getToken();
  return await axios_retry
    .request(config.AUTH_SERVER + "/token/refresh", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
    })
    .then((response) => {
      const result = response.data;
      return result;
    });
};

//POST
export const postAuth = async (url, body) => {
  return apiCall("POST", config.AUTH_SERVER, url, body);
};

export const fetchOnlinePay = async (url, body) => {
  return apiCall("POST", config.ONLINEPAY, url, body);
};

export const fetchMaster = async (url, body) => {
  return apiCall("POST", config.API_SERVER, url, body);
};

export const fetchOperation = async (url, body) => {
  return apiCall("POST", config.OPERATION, url, body);
};

export const fetchFinance = async (url, body) => {
  return apiCall("POST", config.FINANCE, url, body);
};

export const fetchFinanceV2 = async (url, body) => {
  return apiCall("POST", config.FINANCEV2, url, body);
};

export const fetchRisk = async (url, body) => {
  return apiCall("POST", config.RISK, url, body);
};

export const fetchOnboarding = async (url, body) => {
  return apiCall("POST", config.ONBOARDING, url, body);
};

export const postProcessorOnboard = async (url, body) => {
  return apiCall("POST", config.PROCESSOR_ONBOARD, url, body);
};

//GET
export const getMaster = async (url, body) => {
  return apiCall("GET", config.API_SERVER, url, body);
};

export const getOperation = async (url, body) => {
  return apiCall("GET", config.OPERATION, url, body);
};

export const getOnlinePay = async (url, body) => {
  return apiCall("GET", config.ONLINEPAY, url, body);
};

export const getRisk = async (url, body) => {
  return apiCall("GET", config.RISK, url, body);
};

export const getProcessorOnboard = async (url, body) => {
  return apiCall("GET", config.PROCESSOR_ONBOARD, url, body);
};

export const getFinance = async (url, body) => {
  return apiCall("GET", config.FINANCE, url, body);
};

export const getFinanceV2 = async (url, body) => {
  return apiCall("GET", config.FINANCEV2, url, body);
};

//PUT
export const putMaster = async (url, body) => {
  return apiCall("PUT", config.API_SERVER, url, body);
};

export const putOperation = async (url, body) => {
  return apiCall("PUT", config.OPERATION, url, body);
};

export const putRisk = async (url, body) => {
  return apiCall("PUT", config.RISK, url, body);
};

export const putFinance = async (url, body) => {
  return apiCall("PUT", config.FINANCE, url, body);
};

export const putFinanceV2 = async (url, body) => {
  return apiCall("PUT", config.FINANCEV2, url, body);
};

export const putProcessorOnboard = async (url, body) => {
  return apiCall("PUT", config.PROCESSOR_ONBOARD, url, body);
};

//DEL
export const delMaster = async (url, body) => {
  return apiCall("DELETE", config.API_SERVER, url, body);
};

export const delProcessorOffboard = async (url, body) => {
  return apiCall("DELETE", config.PROCESSOR_ONBOARD, url, body);
};

export const deleteFinance = async (url, body) => {
  return apiCall("DELETE", config.FINANCE, url, body);
};
